import { render, staticRenderFns } from "./About.vue?vue&type=template&id=4ce83cd4&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./Landing.scss?vue&type=style&index=0&id=4ce83cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce83cd4",
  null
  
)

export default component.exports